import { Control } from "../Control.js";
import * as dataValidations from "../../data/model/data-validations.js";

export class Editor extends Control {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            readOnly = false,
            loaded = true,
            value = null,
            valueDefault = null,
            valueValidations = null,
            onValueChange = null,
            hint = null,
            autofocus = false,
        } = options;

        this.readOnly = readOnly;
        this.loaded = loaded;
        this.value = value;
        this.valueDefault = valueDefault;
        this.valueValidations = valueValidations;
        this.onValueChange = onValueChange;
        this.hint = hint;
        this.autofocus = autofocus;

    };

    // ------------------------------------------------------------------------

    getValue() {

        return (typeof this.value === 'function' ? this.value.call(this) : this.value);

    };

    getValueDefault() {

        return (typeof this.valueDefault === 'function' ? this.valueDefault.call(this) : this.valueDefault);

    };

    getValueValidations() { return (typeof this.valueValidations === 'function' ? this.valueValidations.call(this) : this.valueValidations); };

    validateValue() { return dataValidations.validateValue(this.getValue(), this.getValueValidations()); };

    getValueError() { return dataValidations.getValueError(this.getValue(), this.getValueValidations()); };

    changeValue(value, forceChange = false, omitRedraw = false, omitRefresh = false) {

        if (!forceChange && this.isValueSame(value))
            return;
        if (typeof this.value != 'function')
            this.value = value;
        if (this.onValueChange)
            this.onValueChange(value);
        if (!omitRefresh)
            this.refresh();
        if (!omitRedraw)
            this.invalidate();

    };

    isValueSame(value) {

        return this.getValue() == value;

    };

    isLoading() {

        return !(typeof this.loaded === 'function' ? this.loaded.call(this) : this.loaded);

    };

    isAutofocus() {

        return (typeof this.autofocus === 'function') ? this.autofocus.call(this) : this.autofocus;

    };

}